(function () {
  function setActiveGallery(root, index) {
    root.querySelectorAll('[data-op-gallery-image]').forEach(function (image) {
      image.classList.toggle('is-hidden', image.getAttribute('data-op-gallery-image') !== index);
    });

    root.querySelectorAll('[data-op-gallery-thumb]').forEach(function (button) {
      button.setAttribute('aria-current', button.getAttribute('data-op-gallery-thumb') === index ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-op-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-op-gallery]');
    if (!gallery) return;

    setActiveGallery(gallery, thumb.getAttribute('data-op-gallery-thumb'));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-op-variant-input]');
    if (!input) return;

    var productRoot = input.closest('[data-op-product]');
    if (!productRoot) return;

    var hiddenInput = productRoot.querySelector('.product-variant-id');
    if (hiddenInput) {
      hiddenInput.value = input.value;
      hiddenInput.disabled = input.dataset.available === 'false';
    }

    var price = productRoot.querySelector('[data-op-price]');
    if (price && input.dataset.price) {
      price.textContent = input.dataset.price;
    }

    var compare = productRoot.querySelector('[data-op-compare]');
    if (compare) {
      compare.textContent = input.dataset.comparePrice || '';
      compare.hidden = !input.dataset.comparePrice;
    }

    var submit = productRoot.querySelector('[type="submit"][name="add"]');
    if (submit) {
      var unavailable = input.dataset.available === 'false';
      submit.disabled = unavailable;

      var label = submit.querySelector('span');
      if (label) {
        var commerceText = (window.OnePillowI18n && window.OnePillowI18n.commerce) || {};
        label.textContent = unavailable ? (commerceText.soldOut || '') : (commerceText.orderNow || '');
      }
    }

    if (input.dataset.galleryIndex) {
      var gallery = productRoot.querySelector('[data-op-gallery]');
      if (gallery) {
        setActiveGallery(gallery, input.dataset.galleryIndex);
      }
    }
  });
})();
